<template>
  <div class="bg-block shadow-primaryBlock rounded relative
              px-8 py-8 lg:px-12 lg:py-13
              mb-8 lg:mb-12">
    <PlannedTransactionEditModal :template="editTemplate"
                                 @close="editTemplate = null"
                                 @success="updatePlannedTransactions"/>
    <div class="mb-6 lg:mb-12 text-xl font-bold text-text leading-tight">
      <span class="">{{ $t('title') }}</span>
    </div>
    <div v-if="loading"></div>
    <template v-else-if="transactions.length">
      <div v-for="(transactions,date,i) in transactionsByDate" :key="i">
        <TransactionDate :date="date" :transactions="transactions"/>
        <PlannedTransactionItem v-for="(transaction,i) in transactions" :key="i"
                                :transaction="transaction"
                                :apply-opacity="true"
                                @edit="startEditTransaction(transaction)"
                                @confirm="confirmEvent"
                                :layout="layoutType === 'tablet' ? 'compact' : 'default'"/>
      </div>
      <div class="mt-10 "
           v-show="current_page < pages_length || more_loading">
                    <span v-if="!more_loading"
                          class="text-2sm text-text-ternary cursor-pointer
                          transition duration-200
                          border-b border-dashed border-text-ternary
                          hover:text-red hover:border-red"
                          @click="showMore">{{ $t('showMore') }}</span>
        <font-awesome-icon class="text-primary" v-else icon="circle-notch" spin/>
      </div>
    </template>
    <div v-else class="text-center text-lg text-text">
      {{ $t('noTransactions') }}
    </div>
  </div>
</template>

<script>
import PlannedTransactionEditModal
  from "@/components/common/PlannedTransaction/PlannedTransactionEditModal/PlannedTransactionEditModal";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import TransactionDate from "@/components/common/Transaction/TransactionDate";
import PlannedTransactionItem
  from "@/components/common/PlannedTransaction/PlannedTransactionItem/PlannedTransactionItem";

export default {
  name: "PlannedTransactions",
  components: {PlannedTransactionItem, TransactionDate, PlannedTransactionEditModal},
  data() {
    return {
      editTemplate: null,
      more_loading: false,
      confirmingTransaction: false
    }
  },
  computed: {
    ...mapGetters('theme', ['layoutType']),
    ...mapState('moneyDashboard/plannedTransactions', {
      loading: state => state.transactions.dirty,
      current_page: state => state.transactions.pagination.current_page,
      pages_length: state => state.transactions.pagination.pages
    }),
    ...mapGetters('moneyDashboard/plannedTransactions', ['transactions', 'transactionsByDate'])
  },
  methods: {
    ...mapActions('moneyDashboard/plannedTransactions', ['getPlannedTransactions', 'loadMorePlannedTransactions']),
    ...mapActions('space/calendar', ['confirmPlannedTransaction']),
    ...mapMutations('moneyDashboard/plannedTransactions', ['setPagePlannedTransactions']),
    updatePlannedTransactions() {
      this.getPlannedTransactions();
    },
    showMore() {
      this.setPagePlannedTransactions(this.current_page + 1);
    },
    startEditTransaction(transaction) {
      this.editTemplate = {
        ...transaction.template,
        next_event_at: transaction.date
      }
    },
    async confirmEvent(id) {
      if (this.confirmingTransaction) return;
      try {
        this.confirmingTransaction = true;
        const res = await this.confirmPlannedTransaction(id)
        if (res.body.success) {
          this.$toasted.success(this.$t('transactionConfirmed'));
          this.getPlannedTransactions();
          this.$emit('updateDashboard');
        } else {
          this.$toasted.error(this.$t('errors.response'));
          console.log(res)
        }
      } catch (err) {
        this.$toasted.error(this.$t('errors.response'));
        console.error(err)
      } finally {
        this.confirmingTransaction = false;
      }
    },
  },
  watch: {
    async current_page(newVal) {
      if (newVal === 1) {
        await this.getPlannedTransactions()
      } else {
        this.more_loading = true
        await this.loadMorePlannedTransactions();
        this.more_loading = false
      }
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Planned transactions',
        transactionConfirmed: 'Transaction confirmed',
        noTransactions: 'No planned transactions',
        showMore: 'Show more',
      },
      ru: {
        title: 'Запланированные операции',
        transactionConfirmed: 'Транзакция подтверждена',
        noTransactions: 'Нет запланированных транзакций',
        showMore: 'Показать больше',
      }
    }
  }
}
</script>